export default {"src":"/_next/static/media/check-circle.17251d71.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};